export default __webpack_public_path__ + "static/media/015-singing karaoke.55ff1bcc.png";